<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      height="calc(100vh - 275px)"
      class="font-resp-tabela"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Fornecedor</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-spacer></v-spacer>

          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog persistent v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Novo</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <v-btn
                color="#000"
                icon
                style="margin-left: -10px"
                @click="close()"
              >
              <v-icon>mdi-close</v-icon>
              </v-btn>
                <span class="headline ml-3">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="pa-0 mt-4" cols="12" xs="12">
                      <v-autocomplete
                        v-model="editedItem.idfornecedor"
                        :items="desserts"
                        label="Selecione um ou mais Fornecedores*"
                        autofocus
                        outlined
                        color="#042333"
                        item-text="id_razao_social"
                        item-value="id"
                        multiple
                        small-chips
                        class="autocomplete-personalizado-com-barra-de-rolagem"
                        :error-messages="fornecedorErrors"
                        @input="$v.editedItem.idfornecedor.$touch()"
                        @blur="$v.editedItem.idfornecedor.$touch()"
                      ></v-autocomplete>

                      <v-autocomplete
                        v-model="editedItem.idcomprador"
                        :items="selects.compradores.items"
                        label="Selecione o nome do Comprador*"
                        clearable
                        outlined
                        color="#042333"
                        item-text="nome_completo"
                        item-value="id"
                        :error-messages="compradorErrors"
                        @input="$v.editedItem.idcomprador.$touch()"
                        @blur="$v.editedItem.idcomprador.$touch()"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.src_modulo="{ item }">
        <v-icon>{{ item.src_modulo }}</v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import Api from "./../../api/cfg";

export default {
  props: ["atualizarForn"],

  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Razão Social",
        align: "left",
        value: "razao_social",
      },
      {
        text: "ID Comprador",
        align: "left",
        value: "idcomprador",
      },
      {
        text: "Nome Comprador",
        align: "left",
        value: "nome_completo",
      },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      idcomprador: "",
      id: "",
    },
    defaultItem: {
      id: "",
      idcomprador: "",
      idfornecedor: ""
    },
    selects: {
      compradores: {
        items: [],
      },
    },
  }),

  validations: {
    editedItem: {
      idcomprador: {
        required
      },
      idfornecedor: {
        required
      }
    },
  },

  computed: {
    compradorErrors() {
      const errors = [];
      if (!this.$v.editedItem.idcomprador.$dirty) return errors;
      !this.$v.editedItem.idcomprador.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    fornecedorErrors() {
      const errors = [];
      if (!this.$v.editedItem.idfornecedor.$dirty) return errors;
      !this.$v.editedItem.idfornecedor.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Comprador" : "Editar Comprador";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarForn() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      Api.getFornecedores(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.fornecedores;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      Api.getCompradores(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.compradores.items = response.data.compradores;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, {
        idfornecedor: [item.id], idcomprador: item.idcomprador}
      );
      this.dialog = true;
    },

    close() {
      this.$v.$reset()
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          Api.addFornecedor(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );

        this.close();
      }
    },
  },
};
</script>
